<template>
  <div>
    <Form :model="newPaper" :rules="newPaperRule" :label-width="80" inline>
      <FormItem label="套卷名称" prop="name">
        <Input v-model="newPaper.name" placeholder="套卷名称" style="width:300px;" clearable></Input>
        <span class="process">{{newPaper.name.length}}/30</span>
      </FormItem>
    </Form>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="试卷类型">
        <Select v-model="searchCondition.type" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in paperType"
            :key="index"
            :value="item.key"
          >{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="试卷分类">
        <Cascader
          v-model="curPaperClassify"
          :data="paperClassify"
          trigger="hover"
          style="width:200px;"
        ></Cascader>
      </FormItem>
      <FormItem label="试卷名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入套卷名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/index"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="single"
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              :to="{name: 'QuestionPaperChooseDetail', query: {id: row.id,type: 1}}"
            >详情</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onFresh('select', 1)">刷新</Button>
        </template>
      </Grid>
    </div>
    <div class="chooose-action">
      <Button :to="{name: 'QuestionPaperPackageManage'}">取消</Button>
      <Button type="primary" @click="onForbidden">发布</Button>
    </div>
  </div>
</template>
<script>
import { QuestionPaperType } from "@/utils/enums";
export default {
  name: "question-paper-choose",
  data() {
    return {
      paperClassify: [],
      curPaperClassify: [],
      paperType: QuestionPaperType.getOptions(),
      searchCondition: {
        status: 1,
        classify_id: "",
        name: "",
        type: "",
        init: function() {
          this.classify_id = "";
          this.name = "";
          this.type = "";
        }
      },
      newPaper: {
        name: ""
      },
      newPaperRule: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "试卷名称", key: "name", minWidth: 180 },
        { title: "所属类型", key: "type_name", minWidth: 100 },
        { title: "所属分类", key: "classify_name", minWidth: 150 },
        { title: "试题数量", key: "question_num", minWidth: 100 },
        { title: "试卷总分", key: "score", minWidth: 100 },
        { title: "创建人", key: "nickname", minWidth: 120 },
        { title: "更新时间", key: "updated_at", minWidth: 160 },
        { title: "操作", slot: "action", fixed: "right", minWidth: 100 }
      ],
      selectItem: []
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.type_name = QuestionPaperType.getValue(item.type);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.curPaperClassify = [];
        this.searchCondition.init();
      }
      if (this.curPaperClassify.length)
        this.searchCondition.classify_id = this.curPaperClassify[
          this.curPaperClassify.length - 1
        ];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(items) {
      this.selectItem = items;
      this.newPaper.name = items[0].name;
    },
    onForbidden() {
      if (this.selectItem.length == 0) {
        this.$Message.error("请选择试卷");
        return;
      }
      this.$http
        .post(`/api/exam/packagePractice`, {
          name: this.newPaper.name,
          exam_id: this.selectItem[0].id
        })
        .then(() => {
          this.$Message.createSuccess("发布成功");
          this.$router.push({
            name: "QuestionPaperPackageManage"
          });
        });
    },
    onFresh() {
      this.search(1);
    },
    getClassify() {
      this.$http.get(`/api/course/classify`).then(res => {
        this.paperClassify = res;
      });
    }
  },
  created() {
    this.getClassify();
  }
};
</script>

<style lang="scss" scoped>
.process {
  margin-left: 10px;
}
.chooose-action {
  text-align: center;
  button {
    margin: 0 20px;
  }
}
</style>
